<div *ngIf="state === states.loginError" [@openClose]>
	<atomic-message-bar class="my-10">
		Unable to fetch details from Stewart. Please try logging in again
	</atomic-message-bar>
	<app-button (click)="goToStewart()">Login to Stewart Title</app-button>
</div>

<div
	*ngIf="state === states.savingAuth || state === states.savedSuccess"
	class="flex flex-col justify-center items-center"
>
	<div class="w-52 mb-10">
		<img src="assets/images/integrations/stewart-title-logo.svg" />
	</div>
	<div class="flex gap-4" *ngIf="state === states.savingAuth">
		<app-icon [spin]="true" [icon]="ICON.LOADING"></app-icon>
		<p>Storing auth credentials</p>
	</div>
	<div
		class="flex flex-col justify-center items-center"
		*ngIf="state === states.savedSuccess"
	>
		<div class="flex gap-4">
			<app-icon
				size="xlarge"
				class="text-green"
				[icon]="ICON.SUCCESS"
			></app-icon>
			<p>Credentials successfully saved!</p>
		</div>
		<app-button (click)="close()" class="mt-10">Close</app-button>
	</div>
</div>
